import { render, staticRenderFns } from "./WalletTileItem.vue?vue&type=template&id=31acb2b1&scoped=true"
import script from "./WalletTileItem.vue?vue&type=script&lang=js"
export * from "./WalletTileItem.vue?vue&type=script&lang=js"
import style0 from "./WalletTileItem.vue?vue&type=style&index=0&id=31acb2b1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31acb2b1",
  null
  
)

export default component.exports